export default "__VITE_ASSET__06a34621__"